import { combineReducers } from '@reduxjs/toolkit';

import { blacksSlice } from './blacks';
import { bookingsSlice } from './bookings';
import { directionsSlice } from './directions';
import { driversSlice } from './drivers';
import { globalSlice } from './global';
import { localitiesSlice } from './localities';
import { optionsSlice } from './options';
import { permissionsSlice } from './permissions';
import { routesSlice } from './routes';
import { schedulesSlice } from './schedules';
import { seasonsSlice } from './seasons';
import { sectorsSlice } from './sectors';
import { stopsSlice } from './stops';
import { usersSlice } from './users';

export const reducers = () =>
    combineReducers({
        global: globalSlice.reducer,
        localities: localitiesSlice.reducer,
        directions: directionsSlice.reducer,
        stops: stopsSlice.reducer,
        options: optionsSlice.reducer,
        seasons: seasonsSlice.reducer,
        sectors: sectorsSlice.reducer,
        drivers: driversSlice.reducer,
        routes: routesSlice.reducer,
        users: usersSlice.reducer,
        permissions: permissionsSlice.reducer,
        blacks: blacksSlice.reducer,
        bookings: bookingsSlice.reducer,
        schedules: schedulesSlice.reducer,
    });
